export const CONFIG_BASE = {
  MODE: 'local',
  ENDPOINT: '',
  ENDPOINT_IMAGE: '',
};
